import { Helmet } from "react-helmet";
import StylishBanner from "../components/Reusable Elements/StylishBanner";
import styles from "../styles/Projects.module.css";
import { useNavigate } from "react-router-dom";
import Button from "../components/Reusable Elements/Button";

const Projects = () => {
    const navigate = useNavigate();

    return (
        <div>
            <Helmet>
                <title>Projects</title>
            </Helmet>
            <div
                className="flex flex-col items-center justify-center"
                style={{ paddingTop: "99px" }}
            >
                <StylishBanner
                    heading={"Projects"}
                    tagline={"Explore our projects"}
                    number={1}
                />
                <div className="text-primary-gold flex justify-center gap-x-12 font-poppins font-extralight text-3xl mt-16 w-screen flex-wrap gap-y-12">
                    <div className={styles.projectCardBackground}>
                        <div className={styles.projectCard} onClick={() => navigate('/pearl-residencia')}>
                            Pearl Residencia
                        </div>
                        <div className={styles.blurryBackgroundTemp} onClick={() => navigate('/pearl-residencia')}>
                            <div className={styles.rectangle}>5 Marla</div>
                            <div className={styles.rectangle}>4 Marla</div>
                            <div className={styles.rectangle}>Townhomes</div>
                        </div>
                    </div>
                    <div className={styles.projectCardBackground}>
                        <div className={styles.blurryBackground}>
                            <div className={styles.projectCardTwo}>
                                Coming soon
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-screen justify-center flex pb-20 pt-10">
                <Button
                    text={"Contact Us"}
                    location={"/contact"}
                    color={'#ffffff'}
                    />
            </div>
        </div>
    );
};

export default Projects;
